
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scout/[[...id]]",
      function () {
        return require("private-next-pages/scout/[[...id]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scout/[[...id]]"])
      });
    }
  